'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper');
var graphicsHelper = require('../../helper/graphicsHelper');

/*
 @Author : mengxiaojiang
 @CreateDate : 2016-3-31
 @Descript : 分组框组件
 */
var GroupBox = React.createClass({
  getInitialState: function () {
    return {
      x: parseInt(this.props.x, 10)
    };
  },
  render: function () {
    var style = {
      width: styleHelper.getWidth(this.props),
      height: styleHelper.getHeight(this.props),
      border: 'none',
      pointerEvent: 'none',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      position: 'absolute',
      left: 0,
      top: 0,
      boxSizing: 'border-box'
    };

    var tx = styleHelper.getText(this.props);
    if (!tx.trim()) {
      tx = '\u00a0';
    }
    styleHelper.StyleUtil(this.props, style).text();
    return (
      <div style={style}>
        <canvas ref="ctx" width={style.width} height={style.height}
                style={{width:'100%',height:'100%',left:0,top:0,position:'absolute',zIndex:0}}/>
        <label ref="tx" style={{
          left:20,
          top:0,
          zIndex:1,
          textDecoration:'inherit',
          position:'absolute'
        }}>{tx}</label>
      </div>
    );
  },

  doAdjustStyle: function () {
    var ctx = ReactDOM.findDOMNode(this.refs.ctx);
    var g = ctx.getContext('2d');
    var thickness = 1;
    var label = ReactDOM.findDOMNode(this.refs.tx);
    var top = Math.round(label.clientHeight / 2) - thickness / 2;
    var tw = label.clientWidth;
    var tx = label.offsetLeft - 2;
    var tr = Math.min(styleHelper.getWidth(this.props) - thickness / 2, tw + tx) + 4;
    var left = thickness / 2;
    var right = styleHelper.getWidth(this.props) - thickness / 2;
    var bottom = styleHelper.getHeight(this.props) - thickness / 2;
    var ratio = graphicsHelper.applyDeviceRatio(g,styleHelper.getWidth(this.props),styleHelper.getHeight(this.props));

    thickness *= ratio;
    tw *= ratio;
    tx *= ratio;
    tr *= ratio;
    left *= ratio;
    right *= ratio;
    bottom *= ratio;
    top *= ratio;

    g.clearRect(0, 0, ctx.width, ctx.height);
    g.lineWidth = thickness;
    g.strokeStyle = styleHelper.getBorderColor(this.props) || '#ddd';
    g.fillStyle = styleHelper.getBackgroundColor(this.props);
    g.beginPath();
    g.rect(0, top, ctx.width, ctx.height - top);
    g.closePath();
    g.fill();

    g.beginPath();
    g.moveTo(tx, top);
    g.lineTo(left, top);
    g.lineTo(left, bottom);
    g.lineTo(right, bottom);
    g.lineTo(right, top);
    g.lineTo(tr, top);
    g.stroke();
  },

  componentDidUpdate: function () {
    this.doAdjustStyle();
  },

  componentDidMount: function () {
    this.doAdjustStyle();
  }
});


module.exports = GroupBox;



// WEBPACK FOOTER //
// ./src/views/Components/GroupBox.jsx